module.exports = __webpack_public_path__ + "img/recruit-icon-5.c4ea5182.png";